export const collectionSources = [
  { code: 'ENACH_WL_LMS', display: 'eNach - Worldline LMS', paymentType: 'eNach' },
  { code: 'ENACH_WL_ALLCLOUD', display: 'eNach - Worldline AllCloud', paymentType: 'eNach' },
  { code: 'ENACH_RAZORPAY', display: 'eNach - Razorpay', paymentType: 'eNach' },
  { code: 'UPI_STATIC_SPRINTNEXT', display: 'UPI - Static - SprintNext', paymentType: 'UPI' },
  { code: 'UPI_DYNAMIC_SPRINTNEXT', display: 'UPI - Dynamic - SprintNext', paymentType: 'UPI' },
  { code: 'UPI_RAZORPAY', display: 'UPI - Razorpay', paymentType: 'UPI' },
  { code: 'AIRTEL_MONEY', display: 'Airtel Money', paymentType: 'Wallet' },
  { code: 'CASH', display: 'Cash', paymentType: 'Cash' },
  { code: 'DIRECT_BANK_DEPOSIT', display: 'Direct Bank Deposit', paymentType: 'Bank' },
  { code: 'BANK_STATEMENT', display: 'Bank Statement', paymentType: 'Bank' },
  { code: 'ALLCLOUD_API', display: 'AllCloud API', paymentType: 'API' },
  { code: 'OTHER_UNKNOWN', display: 'Other / Unknown', paymentType: 'Unknown' },
];

const hiddenCollectionSourceCodes = new Set(['ENACH_WL_ALLCLOUD', 'AIRTEL_MONEY', 'BANK_STATEMENT', 'ALLCLOUD_API']);

export const visibleCollectionSources = collectionSources.filter(
  (source) => !hiddenCollectionSourceCodes.has(source.code),
);

export const isCollectionSourceVisible = (sourceCodeOrLabel) => {
  const source = collectionSources.find(
    (item) => item.code === sourceCodeOrLabel || item.display === sourceCodeOrLabel,
  );
  return !source || !hiddenCollectionSourceCodes.has(source.code);
};

export const exceptionTypes = ['Transaction Not Found', 'Amount Mismatch', 'Duplicate', 'Ambiguous Match', 'Invalid Reference', 'Other'];